import { createSlice } from '@reduxjs/toolkit';
import { fetchSuppliers } from '../actions/supplier.action';

const initialState = {
  suppliers: {
    data: {},
    isLoading: false,
    isNeedReloadData: true,
  },
  currentSupplier: {
    frame: {},
    door: {},
    louveredWall: {},
    32: {},
    31: {},
  },
  specialTexture: {
    frame: true,
    door: true,
    louveredWall: true,
    bedFlap: true,
  },
};

export const supplierReducer = createSlice({
  name: 'Supplier',
  initialState,
  reducers: {
    resetCurrentSupplier: state => {
      state.currentSupplier = {
        frame: {},
        door: {},
        louveredWall: {},
        32: {},
        31: {},
        bedFlap: {},
      };
    },
    setCurrentSupplier: (state, action) => {
      state.currentSupplier = {
        ...state.currentSupplier,
        ...(action.payload ?? {}),
      };
    },
    toggleSpecialTexture: (state, action) => {
      // const { frame, door, louveredWall } = state.specialTexture;
      state.specialTexture = {
        frame: action.payload,
        door: action.payload,
        louveredWall: action.payload,
        bedFlap: action.payload,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSuppliers.pending, state => {
        state.suppliers = {
          ...state.suppliers,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchSuppliers.fulfilled, (state, action) => {
        if (action.payload) {
          const data = action.payload;
          state.suppliers = {
            ...state.suppliers,
            isLoading: false,
            data: { ...state.suppliers.data, ...data },
          };
        }
      });
  },
});

export const {
  resetCurrentSupplier,
  setCurrentSupplier,
  toggleSpecialTexture,
} = supplierReducer.actions;

export default supplierReducer.reducer;
